import { VoucherList } from "@/components/accounting/VoucherList";
import { GSTInvoiceForm } from "@/components/accounting/GSTInvoiceForm";

const PurchasePage = () => (
  <div className="space-y-6">
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-2xl font-bold font-display text-foreground">Purchase Vouchers</h1>
        <p className="text-sm text-muted-foreground">Manage purchase entries — Debit: Purchase Account → Credit: Supplier</p>
      </div>
      <GSTInvoiceForm type="Purchase" />
    </div>
    <VoucherList type="Purchase" title="Purchase Vouchers" description="" hideHeader />
  </div>
);

export default PurchasePage;
